import React from 'react'
import lang from '@/lang'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import { subscriptionLimits } from '@/modules/base/util/constants'
import showUpgradeModalIfNotInPlan from '@/modules/_helpers/showUpgradeModalIfNotInPlan'
import { checkModuleAccess } from '@/modules'
import clsx from 'clsx'
import { NavLink } from 'react-router'
import { setActiveMenuItem } from '@/redux/ducks/menu/main'
import { useAppDispatch } from '@/redux/store'
import { useUpgradeModal } from '@/hooks/useUpgradeModal'

const useStyles = makeStyles((theme) => ({
  link: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 13,
    height: 35,
    width: '100%',
    transition: 'color 0.2s ease-out',
    color: theme.white,
    '&:hover': {
      color: 'var(--nav-submenu-item-color-active)',
    },
  },
  /* current subscription does not include module/ function */
  notallowed: ({ active }) => ({
    display: 'flex',
    alignItems: 'center',
    fontSize: 13,
    fontWeight: active ? 500 : 400,
    height: 35,
    width: '100%',
    color: `var(--nav-submenu-item-color${active ? '-active' : ''})`,
    opacity: 0.4,
    transition: 'color 0.2s ease-out',
    '&:hover': {
      color: 'var(--nav-submenu-item-color)',
      opacity: 1,
    },
  }),
  disabled: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 13,
    height: 35,
    width: '100%',
    opacity: 0.2,
    color: 'var(--nav-submenu-item-color)',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  newBadge: {
    color: 'var(--color-primary)',
    fontSize: 12,
    fontWeight: 500,
    alignSelf: 'flex-start',
    marginLeft: 8,
    marginTop: 9,
  },
  active: {
    color: 'var(--nav-submenu-item-color-active)',
    fontWeight: 500,
  },
}))

const SubmenuItem = (props) => {
  const { title, url, name, parentName, isNew = false, read = true, subscriptionModule, isIncludedInPlan = false } = props
  const styles = useStyles()
  const dispatch = useAppDispatch()
  const openUpgradeModal = useUpgradeModal()

  const newBadge = isNew ? <span className={styles.newBadge}>{lang.menu.newBadge}</span> : null

  const handleOpenUpgradeModal = (subscriptionModule) => {
    const isMutiple = Array.isArray(subscriptionModule)

    if (isMutiple) {
      const results = subscriptionModule.map((module) => ({ module, isInPlan: checkModuleAccess(module) }))
      const notInPlan = results.every((result) => result.isInPlan === false)
      if (notInPlan) {
        openUpgradeModal({
          limitReached: subscriptionLimits.DEFAULT_NOTINPLAN,
        })
      }
    } else {
      showUpgradeModalIfNotInPlan(subscriptionModule)
    }
  }

  const qsId = `global-submenu-item-${name}`
  const control = url
    ? (
      isIncludedInPlan !== false && isIncludedInPlan !== undefined && read
        ? (
          <NavLink
            data-nav="subMenuItem"
            className={({ isActive }) => {
              return clsx(
                styles.link,
                isActive && styles.active,
              )
            }}
            data-qs-id={qsId}
            to={url}
            onClick={() => {
              dispatch(setActiveMenuItem(parentName))
            }}
          >
            {title}
          </NavLink>
        )
        : (
          <a
            data-nav="subMenuItem"
            className={`${styles.notallowed}`}
            data-href={url}
            data-qs-id={qsId}
            onClick={() => {
              handleOpenUpgradeModal(subscriptionModule)
            }}
          >
            {title}
          </a>
        )
    )
    : (
      <div className={styles.disabled}>{title}</div>
    )

  return (
    <div className={styles.container}>
      {control}
      {newBadge}
    </div>
  )
}

SubmenuItem.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string,
  name: PropTypes.string.isRequired,
  isNew: PropTypes.bool,
  read: PropTypes.bool,
  isIncludedInPlan: PropTypes.bool,
}

export default SubmenuItem
